// Tracks which "verified" brand/audience/category combinations this device
// has already been shown, so the nav bell can surface genuinely new ones —
// never a fabricated count. See src/hooks/useNewlyVerified.ts.

const KEY = 'fitmap:seen-verified-brands';

/** Returns null when this device has never checked before (vs. an empty array, meaning it checked and nothing was verified yet). */
export function getSeenVerifiedKeys(): string[] | null {
  if (typeof window === 'undefined') return null;
  try {
    const raw = window.localStorage.getItem(KEY);
    if (raw === null) return null;
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed.filter((v): v is string => typeof v === 'string') : null;
  } catch {
    return null;
  }
}

export function markSeenVerifiedKeys(keys: string[]): void {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.setItem(KEY, JSON.stringify(keys));
  } catch {
    // Storage unavailable — the bell just won't persist state for next visit.
  }
}
